import React, { useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';

const Dropdown = ({ className, children, show, onClose }) => {
  const wrapperRef = useRef(null);

  const handleClickOutside = useCallback(
    event => {
      if (!wrapperRef.current?.contains(event.target)) {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef, onClose, handleClickOutside]);

  if (show) {
    return (
      <div className={className} data-testid="dropdown" ref={wrapperRef}>
        <div className="dropdown">{children}</div>
      </div>
    );
  }

  return null;
};

Dropdown.defaultProps = {
  className: '',
  show: false
};

Dropdown.propTypes = {
  className: PropTypes.string,
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};

export default Dropdown;
